import { SD_STATUS } from '../../consts';
var IDs = {};
export default {
    IDs: IDs,
    getData: function (item) { return item; },
    getSdStatus: function () { return SD_STATUS.DOES_NOT_EXIST; },
    getKeys: function () { return []; },
    getSdKeys: function () { return []; },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
};
